import type {
  MainStateType,
  PagesStateType,
  ActivePageStateType,
  EntitiesStateType,
  PageCustomizationsStateType,
} from './context';
import {
  PagesActions,
  ActionTypes,
  EntitiesActions,
  PageCustomizationsActions,
  WebsiteCustomizationsFormActions,
  TmpSelectedThemeActions,
  TmpWebsiteTitleActions,
} from './actionTypes';

export const pagesReducer = (state: PagesStateType, action: PagesActions): PagesStateType => {
  switch (action.type) {
    case ActionTypes.RECEIVE_PAGE:
      return [
        ...state.map(page => (page.id === action.payload.page.id ? action.payload.page : page)),
      ];
    case ActionTypes.RECEIVE_PAGES:
      return [...action.payload.pages];
    default:
      return state;
  }
};

export const activePageReducer = (
  state: MainStateType,
  action: PagesActions
): ActivePageStateType => {
  switch (action.type) {
    case ActionTypes.SET_ACTIVE_PAGE:
      return { ...state.pages.find(page => page.type === action.payload.activePageType) };
    default:
      return state.activePage;
  }
};

export const entitiesReducer = (
  state: EntitiesStateType,
  action: EntitiesActions
): EntitiesStateType => {
  switch (action.type) {
    case ActionTypes.RECEIVE_ENTITIES:
      return {
        ...state,
        ...action.payload.entities,
      };
    default:
      return state;
  }
};

export const pageCustomizationsReducer = (
  state: PageCustomizationsStateType,
  action: PageCustomizationsActions
): PageCustomizationsStateType => {
  switch (action.type) {
    case ActionTypes.RECEIVE_PAGE_CUSTOMIZATIONS:
      return {
        ...state,
        ...action.payload.pageCustomizations,
      };
    default:
      return state;
  }
};

export const websiteCustomizationsFormReducer = (
  state: MainStateType['websiteCustomizationsForm'],
  action: WebsiteCustomizationsFormActions
): MainStateType['websiteCustomizationsForm'] => {
  switch (action.type) {
    case ActionTypes.RECEIVE_WEBSITE_CUSTOMIZATIONS_FORM:
      return {
        ...state,
        ...action.payload.websiteCustomizationsForm,
      };
    case ActionTypes.CLEAR_WEBSITE_CUSTOMIZATIONS_FORM:
      return undefined;
    default:
      return state;
  }
};

export const tmpSelectedThemeKeyReducer = (
  state: MainStateType['tmpSelectedTheme'],
  action: TmpSelectedThemeActions
): MainStateType['tmpSelectedTheme'] => {
  switch (action.type) {
    case ActionTypes.RECEIVE_TEMP_SELECTED_THEME:
      return action.payload.tmpSelectedTheme;
    default:
      return state;
  }
};

export const tmpWebsiteTitleReducer = (
  state: string | undefined,
  action: TmpWebsiteTitleActions
): string | undefined => {
  switch (action.type) {
    case ActionTypes.RECEIVE_TEMP_WEBSITE_TITLE:
      return action.payload.tmpWebsiteTitle;
    default:
      return state;
  }
};

export const mainReducer = (
  {
    activePage,
    pages,
    entities,
    pageCustomizations,
    websiteCustomizationsForm,
    tmpSelectedTheme,
    tmpWebsiteTitle,
  }: MainStateType,
  action:
    | PagesActions
    | EntitiesActions
    | PageCustomizationsActions
    | WebsiteCustomizationsFormActions
    | TmpSelectedThemeActions
    | TmpWebsiteTitleActions
): MainStateType => {
  return {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ activePage: ActivePageStateTyp...
    activePage: activePageReducer({ activePage, pages }, action),
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PagesActions | RECEIVE_ENTITIES_...
    entities: entitiesReducer(entities, action),
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PagesActions | RECEIVE_ENTITIES_...
    pages: pagesReducer(pages, action),
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PagesActions | RECEIVE_ENTITIES_...
    pageCustomizations: pageCustomizationsReducer(pageCustomizations, action),
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PagesActions | RECEIVE_ENTITIES_...
    websiteCustomizationsForm: websiteCustomizationsFormReducer(websiteCustomizationsForm, action),
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PagesActions | RECEIVE_ENTITIES_...
    tmpSelectedTheme: tmpSelectedThemeKeyReducer(tmpSelectedTheme, action),
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'PagesActions | RECEIVE_ENTITIES_...
    tmpWebsiteTitle: tmpWebsiteTitleReducer(tmpWebsiteTitle, action),
  };
};
